"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

// Useful for when other components try to inject props into a component.
// Mostly used with UIFormControl.
var SimpleWrapper = function SimpleWrapper(_ref) {
  var children = _ref.children;
  return _react.default.createElement("span", null, children);
};

SimpleWrapper.propTypes = {
  children: _react.PropTypes.node
};
var _default = SimpleWrapper;
exports.default = _default;
module.exports = exports.default;